import { Button, Grid, Typography, withStyles, WithStyles } from '@material-ui/core';
import { equals } from 'ramda';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PageLoader } from '~components/Page';
import { appDetailRoutes } from '~constants/index';

import { styles } from './UnitInfoDialog/UnitNotesDialog.styles';

import { boundActions, selectors } from '~store';
import { Dialog, DialogContent, DialogActions, DialogTitle, DataPlaceholder, NavLink } from '~ui-kit';

type AcknowledgedByDialogProps = WithStyles<typeof styles> & {
    open: boolean;
    id: number;
    dateTime: string;
    onClose: () => void;
    backTo?: string;
};

export const AcknowledgedByDialog = withStyles(styles)(({
  open = false,
  id,
  dateTime,
  onClose,
  backTo,
  classes,
}: AcknowledgedByDialogProps) => {
  if (!open) {
    return null;
  }

  const { acknowledgedByInfo: isLoading } = useSelector(selectors.alarms.getAlarmsLoaders, equals);
  const acknowledgedByInfo = useSelector(selectors.alarms.getAcknowledgedByInfo, equals);

  useEffect(() => {
    boundActions.alarms.fetchAcknowledgedByInfoInit({ id });
  }, [id]);

  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
      <DialogTitle title="Acknowledged" />
      <DialogContent>
        { isLoading ?
          <PageLoader /> :
          (acknowledgedByInfo.userName ?
            <Grid container>
              <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.noteTitle}>
                    User Name
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" className={classes.noteTitle}>
                    Date & Time
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <NavLink to={appDetailRoutes.userDetails(acknowledgedByInfo.userId, backTo)}>
                  {acknowledgedByInfo.userName}
                </NavLink>
              </Grid>
              <Grid item xs={6}>
                {dateTime}
              </Grid>
            </Grid> :
            <DataPlaceholder />
          )
        }
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onClose}>
        Close
        </Button>
      </DialogActions>
    </Dialog>
  );
});
